import React from 'react';
import './Input.css';

import { API_BASE } from '../config';

import Button from '../components/Button';
import ToolTip from '../components/ToolTip';
import Notification from './Notification';

export default React.createClass({
  
  componentDidMount: function() {
    // custom formatting
    if (this.props.format == "usdollars") {
      this._formatMoney(this.state.value);
    }
  },

  componentWillReceiveProps: function(newProps) {
    
    // custom formatting
    if (this.props.format == "usdollars") {
      
      this._formatMoney(newProps.value);
    
    } else {
      
      this.setState({
        value:newProps.value || ""
      });
    
    }
  },

  focus: function() {
    this.refs.theinput.focus();
  },

  getInitialState: function() {
    return {
      value: this.props.value || "",
      changed:false,
      hideTyping:true,
      notificationText:"",
      saved:true,
      saving:false
    };
  },
  
  handleBlur: function(event) {
    if (this.state.changed && !this.props.noSave && !this.props.saveButton) { // only fire if value changed
      this._save();
    }
    if (this.props.onBlur) {
      this.props.onBlur(this.props.name,this.value());
    }
  },

  handleChange: function(event) {
    
    var changed = true;

    this.setState({
      value: event.target.value,
      changed:changed,
      saved:false
    },function() {
      if (this.props.onChange) {
        this.props.onChange(this.props.name,this.value());
      }
    });
  },
  
  reset: function() {
    this.setState({
      value: this.props.value
    },function() {
      if (this.props.onChange) {
        this.props.onChange(this.props.name,this.value());
      }
    });
  },
  
  render: function() {

    if (this.props.textarea) {

      var className = "";
      if (this.props.className) { className += this.props.className; }
      if (!this.state.value) { className += " empty"; }

      return (
          <div className="fieldSet">
            <Notification text={this.state.notificationText} />
            {this.props.label ? <div className="clearflex justify-flex-start">
              <label data-for={this.props.name}>{this.props.label}</label>
            </div> : "" }
            <textarea className={className} style={this.props.style} value={this.state.value} onChange={this.handleChange} onBlur={this.handleBlur} />
          </div>
      );
    } else {

      var className = "";
      if (this.props.className) { className += this.props.className; }
      if (!this.state.value) { className += " empty"; }

      return (
          <div className="fieldSet">
            <Notification text={this.state.notificationText} />
            {this.props.label ? <div className="clearflex justify-flex-start">
              <label data-for={this.props.name}>{this.props.label} {this.props.tooltip ? <ToolTip tip={this.props.tooltip} /> : null}</label>
            </div> : "" }
            <input ref="theinput" className={className} style={this.props.style} type={this.props.hidable ? this.state.hideTyping > 0 ? "password" : this.props.type : this.props.type} placeholder={this.props.placeholder} pattern={this.props.pattern} autoCapitalize={this.props.hidable ? "none" : this.props.autocapitalize} name={this.props.name} value={this.state.value} onChange={this.handleChange} onBlur={this.handleBlur} onKeyDown={this._keyboardListen_enter} disabled={this.props.disabled ? true : false} />
            {this.props.hidable ? <label><a onClick={this._showHideTyping}>{this.state.hideTyping ? "Show typing" : "Hide typing"}</a></label> : "" }
            {this.props.saveButton ? <Button text="Save" onClick={this._save} /> : "" }
          </div>
      );
    }
  },

  value: function() {
    if (this.props.format == "usdollars") {
      return this.state.value.replace(/,/g,"").replace("$","").replace(/k/i,"000");
    } else if (this.props.format == "usdate") {
      return this.state.value.replace(/\./g,"/").replace(/-/g,"/");
    } else {
      return this.state.value;
    }
  },

  _formatMoney(number){
    var n = number;
    var c = 2; //isNaN(c = Math.abs(c)) ? 2 : c; 
    var d = d == undefined ? "." : d;
    var t = t == undefined ? "," : t; 
    var s = n < 0 ? "-" : "", 
        i = String(parseInt(n = Math.abs(Number(n) || 0).toFixed(c))), 
        j = (j = i.length) > 3 ? j % 3 : 0;
    this.setState({
      value : s + "$" + (j ? i.substr(0, j) + t : "") + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + t) + (c ? d + Math.abs(n - i).toFixed(c).slice(2) : "")
    });
  },

  _showHideTyping() {
    this.setState({
      hideTyping:!this.state.hideTyping
    })
  },

  _keyboardListen_enter(e) {
      if (this.props.onKeyDown) {
        this.props.onKeyDown(e);
      }

      if (e.keyCode === 13) {
          this.handleBlur(e);
          e.target.blur();
      }
  },

  _save: function() {

      var _this = this;

      // get values for update
      var endpoint = this.props.endpoint;
      var id = this.props.id;
      var field = this.props.name;
      var value = this.value(); //this.state.value;

      // enocde &
      value = value.replace("&","%26");

      var request = new Request(`${API_BASE}`+endpoint+"/"+id+"?"+field+"="+value, {
        method: 'PUT', 
        mode: 'cors', 
        headers: new Headers({
          'Authorization': localStorage.getItem('token')
        })
      });

      _this.setState({ notificationText:"Saving..." });
      fetch(request).then(function(response) {

        if (response.status == 200) {
          _this.setState({
            notificationText:"Saved 👍"
          });

          if (_this.props.onSave) {
            _this.props.onSave(field,value);
          }
        }

        if (response.status == 400) {
          return response.json();
        }
        
      }).then(function(json) { // don't need json... blank on successful response
        //console.log(json);

        if (json.error) {
          _this.setState({
            notificationText:json.error
          });
        }
        

      }).catch(function(ex) {
        console.log('parsing failed', ex);
      });

  }

})


// WEBPACK FOOTER //
// ./src/components/Input.js